<template>
  <section>
    <div v-if="status">
      <div class="container items-center px-5 py-12 lg:px-20">
        <div
          class="
            flex flex-col
            w-full
            max-w-md
            p-10
            mx-auto
            my-6
            mt-36
            border-2 border-blue-500
            transition
            duration-500
            ease-in-out
            transform
            bg-white
            rounded-lg
          "
        >
          <subscription-modal
            :hide="hidePay"
            :amount="amount"
            :orderId="orderId"
            :name="name"
            :email="email"
            :mobileno="mobileNo"
            :description="'Employment Transaction'"
          />
        </div>
      </div>
    </div>
    <div
      v-else
      class="
        relative
        mt-36
        flex
        items-center
        justify-center
        w-1/2
        py-12
        mx-auto
      "
    >
      <div
        class="text-center border-2 border-blue-500 rounded-2xl indicator p-5"
      >
        <div>
          <div class="p-6 mx-auto">
            <span
              class="
                mb-8
                text-xs
                font-bold
                tracking-widest
                text-blue-600
                uppercase
              "
            >
              Employment Registration Fees
            </span>
            <strong
              class="
                flex
                items-end
                justify-center
                mx-auto
                mt-4
                mb-8
                text-3xl
                font-black
                leading-none
                text-center text-blue-600
                lg:text-5xl
              "
            >
              &#8377;100 <span class="text-sm text-gray-500">One time </span>
            </strong>
            <span
              class="mx-auto font-bold leading-none tracking-tighter text-3xl"
            >
              Avail our services
            </span>
            <p class="mt-5 text-gray-500 text-base">
              Applicants can register themselves by making a one time fee of
              <span class="text-xl font-bold font-sans">&#8377;100</span>. No
              further charges are intended to collected from them for any number
              of times they become potential candidates in a recruiment
              exercise. Applicants can update their profile on the Portal on a
              regular basis based on the upgradation of their skills.
            </p>

            <div class="indicator-item indicator-center w-full">
              <p class="btn btn-primary btn-disabled">
                Kindly Pay using UPI or Net Banking
              </p>
            </div>

            <div v-if="verification" class="mt-9">
              <div class="flex flex-col items-center justify-center">
                <img
                  src="../../assets/invoice.png"
                  alt="invoice verifying"
                  class="w-28 animate-bounce"
                />
                <p class="text-lg font-bold w-1/2">
                  We are verifying Your Payment status, Please Wait for a few
                  Seconds.
                </p>
              </div>
            </div>
            <div class="mt-6 flex items-center justify-center" v-if="loading">
              <div
                data-tip="First Fill out Your application"
                class="tooltip"
                v-if="Object.keys(userInfo).length == 0"
              >
                <router-link
                  class="
                    flex
                    items-center
                    justify-center
                    w-max
                    px-10
                    font-bold
                    py-4
                    text-base text-center text-white
                    transition
                    duration-500
                    ease-in-out
                    transform
                    bg-blue-600
                    rounded-xl
                    hover:bg-blue-700
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-blue-500
                  "
                  :to="{ name: 'application' }"
                >
                  Fill the Application first
                </router-link>
              </div>
              <button
                v-else
                @click="showPay"
                class="
                  flex
                  items-center
                  justify-center
                  w-max
                  px-10
                  font-bold
                  py-4
                  text-base text-center text-white
                  transition
                  duration-500
                  ease-in-out
                  transform
                  bg-blue-600
                  rounded-xl
                  hover:bg-blue-700
                  focus:outline-none
                  focus:ring-2
                  focus:ring-offset-2
                  focus:ring-blue-500
                "
                :class="[paymentStatus ? 'btn-disabled' : '']"
              >
                {{ paymentStatus ? "Payment sucessful" : "Pay now" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import subscriptionModal from "../../components/subscriptionModal.vue";
export default {
  name: "subscription",
  components: { subscriptionModal },
  data() {
    return {
      status: false,
      verification: true,
      id: sessionStorage.getItem("id"),
      name: "",
      orderId: "",
      amount: Number(""),
      userInfo: {},
      loading: false,
      paymentStatus: false,
      mobileNo: "",
      email: "",
    };
  },

  mounted() {
    this.getUserinfo();
    this.getUserinfos();
    this.getPayment();
  },
  methods: {
    getPayment() {
      axios
        .post(
          ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/selectPayment`,
          {
            Reg_id: sessionStorage.getItem("id"),
          }
        )
        .then((res) => {
          // console.log(res.data);
          if (res.data[0].paymentStatus == "Failure") {
            this.paymentStatus = false;
          } else if (res.data[0].paymentStatus == "Success") {
            this.paymentStatus = true;
          }
        })
        .catch((err) => console.log(err));
    },
    getUserinfo() {
      axios
        .post(
          ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/CandidatesDetails`,
          {
            Reg_id: sessionStorage.getItem("id"),
          }
        )
        .then((res) => {
          // console.log(res.data);
          if (res.data.length == 0) {
            this.name = "";
            this.mobileNo = "";
            this.email = "";
          } else {
            this.name = res.data[0].Candidate_name;
            this.email = res.data[0].Candidate_mailid;
            this.mobileNo = res.data[0].Candidate_mobileno;
          }
        })
        .catch((err) => console.log(err));
    },
    getUserinfos() {
      axios
        .post(
          ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/SelectApplication`,
          {
            Reg_id: sessionStorage.getItem("id"),
          }
        )
        .then((res) => {
          // console.log(res.data);
          this.verification = false;
          this.loading = true;
          for (const [key, value] of Object.entries(res.data[0])) {
            this.userInfo[key] = value;
          }
          // console.log(JSON.stringify(this.userInfo));
        })
        .catch((err) => console.log(err));
      this.loading = false;
    },
    showPay() {
      this.status = !this.status;
      const defaults = {
        orderdetails: [{ receipt: this.name, amount: 100 }],
        customerid: this.id,
        orderType: 6,
        ...this.userInfo,
      };

      axios
        .post(
          `https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/onlineserviceapi/index.php/api/insert_empservice_payment_transcations`,
          defaults
        )
        .then((res) => {
          this.amount = res.data.payload.amount;
          this.orderId = res.data.payload.order_id;
        })
        .catch((err) => console.log(err));
    },
    hidePay() {
      this.status = !this.status;
      (this.orderId = ""), (this.amount = "");
    },
  },
};
</script>
